import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { PrintTemplateOption } from '..';

@Injectable({ providedIn: 'root' })
export class PrintTemplateOptionService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}`;

  loadPrintTemplates(): Observable<{
    count: number;
    result: PrintTemplateOption[];
  }> {
    return this.http.get<{ count: number; result: PrintTemplateOption[] }>(
      `${this.baseUrl}/printtemplates`
    );
  }
}
